angular.module('dnecom')
    .controller('ProductProcessShippingModalController', ["$scope", "$uibModalInstance", "priceRanges", function ($scope, $uibModalInstance, priceRanges) {
        $scope.priceRanges = priceRanges || [];
        $scope.priceRangeSelectorEnabled = false;

        $scope.showPriceRangeSelector = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            $scope.priceRangeSelectorEnabled = true;
        };

        $scope.hidePriceRangeSelector = function () {
            var result = $scope.priceRangeSelectorEnabled;

            $scope.priceRangeSelectorEnabled = false;

            return result;
        };

        $scope.getNumberSuffix = function (number) {
            var lastDigit = number % 10;
            var lastTwoDigits = number % 100;

            if (lastDigit == 1 && lastTwoDigits != 11) {
                return 'st';
            }

            if (lastDigit == 2 && lastTwoDigits != 12) {
                return 'nd';
            }

            if (lastDigit == 3 && lastTwoDigits != 13) {
                return 'rd';
            }

            return 'th';
        };

        $scope.getMinNumberForRange = function (index) {
            if (!index) {
                return 2;
            }

            var range = $scope.priceRanges[index - 1];

            var minNumber = range.number || range.numberTo || range.numberFrom || $scope.getMinNumberForRange(index - 1);

            return parseInt(minNumber) + 1;
        };

        $scope.getMinNumberForToRange = function (index) {
            var range = $scope.priceRanges[index];

            return parseInt(range.numberFrom) + 1;
        };

        $scope.addPriceRange = function (type, $event) {

            if (!_.isUndefined($event)) {
                $event.preventDefault();
            }

            var range = {
                'type': type
            };

            var minNumber = 2;
            if ($scope.priceRanges) {
                minNumber = $scope.getMinNumberForRange($scope.priceRanges.length);
            }

            if (type == 'single') {
                range.number = minNumber;
            } else {
                range.numberFrom = minNumber;
                range.numberTo = range.numberFrom + 1;
            }

            $scope.priceRanges.push(range);
        };

        $scope.removePriceRange = function (priceRange) {
            $scope.priceRanges.forEach(function (priceRange2, index) {
                if (priceRange == priceRange2) {
                    $scope.priceRanges.splice(index, 1);
                }
            });
        };

        $scope.close = function () {
            $uibModalInstance.dismiss('close');
        };

        $scope.save = function () {
            $uibModalInstance.close($scope.priceRanges);
        };

        $(window).click(function () {
            if ($scope.hidePriceRangeSelector()) {
                $scope.$digest();
            }
        });
    }])
;
